<template>
  <div id="overview-equipment-tab">
    <div>
      <v-container class="content-wrapper" fluid>
        <v-row justify="center" align="center">
          <v-col cols="12" lg="10">
            <v-card
              class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
              elevation="3"
              style="border-radius: 24px;"
            >
              <!-- Back to the Equipments -->
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="auto">
                    <v-btn
                      depressed
                      rounded
                      small
                      color="blue"
                      class="white--text font-weight-bold"
                      @click="goBack"
                    >
                      <v-icon color="black" small class="mr-2">
                        mdi-arrow-left
                      </v-icon>
                      Back
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <!-- Logo Hosting and Logo Equipment -->
              <v-card-text>
                <v-row align="center" justify="start">
                  <v-col cols="12" md="6" sm="6" lg="6" xl="6">
                    <v-img
                      :src="equipment.logo"
                      class="resource-image"
                      lazy-src="@/assets/img/blur.jpg"
                      contain
                      style="max-width: 200px; border-radius: 19.875px;"
                    ></v-img>
                    <!-- <v-card-text class="mt-5">
                      <v-icon>mdi-eye</v-icon>
                      {{ equipment.views }} registered views
                    </v-card-text>
                    <v-card-text class="pt-0">
                      <v-icon>mdi-eye</v-icon>
                      {{ equipment.nonRegisteredViews }} non registered views
                    </v-card-text> -->
                  </v-col>
                  <v-col cols="12" md="6" sm="6" lg="6" xl="6" class="d-flex justify-end">
                    <v-img
                      v-if="equipment.picture"
                      :src="equipment.picture"
                      class="resource-image"
                      lazy-src="@/assets/img/blur.jpg"
                      contain
                      style="width: 100%; max-width: 350px; max-height: 100%; border-radius: 19.875px;"
                    ></v-img>
                  </v-col>
                </v-row>
              </v-card-text>

              <!--  Main Body-->
              <v-card-text>
                <v-row align="center" no-gutters>
                  <v-col cols="auto">
                    <h2 class="black--text">
                      {{ equipment.name }}
                    </h2>
                  </v-col>
                  <v-col cols="auto" class="mx-4">
                    <v-btn @click.stop="modalLogIn = true" elevation="2" icon raised medium>
                      <v-icon>mdi-heart-outline</v-icon>
                    </v-btn>
                  </v-col>
                  <!-- <v-col>
                    <v-btn @click.stop="modalLogIn = true" elevation="2" icon raised medium>
                      <v-icon>mdi-email-outline</v-icon>
                    </v-btn>
                  </v-col> -->
                </v-row>
              </v-card-text>
              <v-card-text class="pt-0">
                <v-chip flat label medium color="blue" class="white--text font-weight-bold">
                  Equipment
                </v-chip>
              </v-card-text>
              <v-card-text v-if="equipment.description">
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <h3 class="primary200--text">
                      Description
                    </h3>
                    <div v-html="equipment.description"></div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text
                v-if="equipment.provider && equipment.provider.id && equipment.provider.name"
              >
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <h3 class="primary200--text">
                      Provider:
                    </h3>
                    <template v-if="equipment && equipment.provider && equipment.provider.id">
                      <router-link
                        :to="{
                          name: 'PublicOverviewProvider',
                          params: { id: equipment.provider.id },
                        }"
                        style="text-decoration: underline; color: inherit;"
                      >
                        {{ equipment.provider.name }}
                      </router-link>
                    </template>
                    <template v-else>
                      <span>No provider available</span>
                    </template>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text
                v-if="
                  equipment.provider.hostingInstitution &&
                    equipment.provider.hostingInstitution.id &&
                    equipment.provider.hostingInstitution.name
                "
              >
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <h3 class="primary200--text">
                      Hosting Institution Entity:
                    </h3>
                    <router-link
                      :to="{
                        name: 'PublicOverviewHostingInstitution',
                        params: { id: equipment.provider.hostingInstitution.id },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ equipment.provider.hostingInstitution.name }}
                    </router-link>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-if="equipment.tags.length">
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <h3 class="primary200--text">
                      Tags
                    </h3>
                  </v-col>
                </v-row>
                <v-row v-if="equipment.tags.length > 0">
                  <v-chip
                    :color="color(index)"
                    v-for="(tag, index) in equipment.tags"
                    :key="index"
                    class="ma-2"
                  >
                    {{ tag }}
                  </v-chip>
                </v-row>
              </v-card-text>
              <v-card-text class="mt-5">
                <v-row>
                  <v-col cols="2">
                    <v-btn
                      @click.stop="modalLogIn = true"
                      block
                      depressed
                      rounded
                      large
                      color="primary200"
                      class="white--text font-weight-bold"
                    >
                      <v-icon color="white" class="mr-2">mdi-cart-outline</v-icon>
                      {{ !ordersPending ? 'Order Request' : 'Order Status' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>

              <!-- Overview Equipment tabs -->
              <v-card-text>
                <v-tabs v-model="tab" show-arrows active-class="primary200--text">
                  <v-tabs-slider color="primary200"></v-tabs-slider>
                  <v-tab v-if="basicInfoTab">{{ $t('basic') }}</v-tab>
                  <v-tab v-if="classificationTab">{{ $t('classification') }}</v-tab>
                  <!-- <v-tab v-if="contactTab">{{ $t('contact') }}</v-tab> -->
                  <v-tab v-if="managementTab">{{ $t('management') }}</v-tab>
                  <v-tab v-if="pricingTab">{{ $t('pricing') }}</v-tab>
                  <v-tab v-if="additionalInfoTab">{{ $t('additional-information') }}</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                  <!-- Basic Info -->
                  <v-tab-item
                    v-if="basicInfoTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="0"
                  >
                    <v-row class="mt-10">
                      <v-col v-if="equipment.basicInfo.prerequisites" cols="12" md="2" sm="12">
                        <label>Prerequisites</label>
                        <div v-html="equipment.basicInfo.prerequisites"></div>
                      </v-col>
                      <v-col v-if="equipment.basicInfo.webpage" cols="12" md="2" sm="12">
                        <label>Webpage</label>
                        <p>
                          {{ equipment.basicInfo.webpage }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="equipment.basicInfo.tagline" class="mt-0 pt-0">
                      <v-col cols="12" md="2" sm="12">
                        <label>Tagline</label>
                        <p>
                          {{ equipment.basicInfo.tagline }}
                        </p>
                      </v-col>
                      <v-col v-if="equipment.basicInfo.useCases.length" cols="12" md="2" sm="12">
                        <label>Use Case</label>
                        <p>
                          <span
                            v-for="(useCase, index) in equipment.basicInfo.useCases"
                            :key="index"
                          >
                            {{ useCase }}
                            <span v-if="index < equipment.basicInfo.useCases.length - 1">, </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0 pt-0">
                      <v-col v-if="equipment.basicInfo.manufacturer" cols="12" md="2" sm="12">
                        <label>Manufacturer</label>
                        <p>
                          {{ equipment.basicInfo.manufacturer }}
                        </p>
                      </v-col>
                      <v-col v-if="equipment.basicInfo.modelAndType" cols="12" md="2" sm="12">
                        <label>Model & Type</label>
                        <p>
                          {{ equipment.basicInfo.modelAndType }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0 pt-0">
                      <v-col v-if="equipment.basicInfo.operationalMode" cols="12" md="2" sm="12">
                        <label>Operational Model</label>
                        <p>
                          {{ equipment.basicInfo.operationalMode }}
                        </p>
                      </v-col>
                      <v-col v-if="equipment.basicInfo.availabilityPolicy" cols="12" md="2" sm="12">
                        <label>Available Policy</label>
                        <p>
                          {{ equipment.basicInfo.availabilityPolicy }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <!-- Classification Info -->
                  <v-tab-item
                    v-if="classificationTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="1"
                  >
                    <v-row v-if="equipment.classificationInfo.domains.length" class="mt-10">
                      <v-col cols="12" md="2" sm="12">
                        <label v-if="equipment.classificationInfo.domains.length > 1"
                          >Scientific domains</label
                        >
                        <label v-else>Scientific Domain</label>
                        <p>
                          <span
                            v-for="(domain, index) in equipment.classificationInfo.domains"
                            :key="index"
                          >
                            {{ domain.domain }}
                            <span v-if="index < equipment.classificationInfo.domains.length - 1"
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                      <v-col cols="12" md="2" sm="12">
                        <label v-if="equipment.classificationInfo.domains.length > 1"
                          >Scientific Subdomain</label
                        >
                        <label v-else>Scientific Subdomain</label>
                        <p>
                          <span
                            v-for="(subdomain, index) in equipment.classificationInfo.domains"
                            :key="index"
                          >
                            {{ subdomain.subDomain }}
                            <span v-if="index < equipment.classificationInfo.domains.length - 1"
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="equipment.classificationInfo.categories.length" class="mt-0 pt-0">
                      <v-col cols="12" md="2" sm="12">
                        <label>Category</label>
                        <p>
                          Instruments & Equipment
                        </p>
                      </v-col>
                      <v-col cols="12" md="2" sm="12">
                        <label v-if="equipment.classificationInfo.categories.length > 1"
                          >Subcategories</label
                        >
                        <label v-else>Subcategory</label>
                        <p>
                          <span
                            v-for="(subcategory, index) in equipment.classificationInfo.categories"
                            :key="index"
                          >
                            {{ subcategory.subCategory }}
                            <span v-if="index < equipment.classificationInfo.categories.length - 1"
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="equipment.classificationInfo.accessModes.length" class="mt-0 pt-0">
                      <v-col cols="12" md="2" sm="12">
                        <label v-if="equipment.classificationInfo.accessModes.length > 1"
                          >Access Modes</label
                        >
                        <label v-else>Access Mode</label>
                        <p>
                          <span
                            v-for="(mode, index) in equipment.classificationInfo.accessModes"
                            :key="index"
                          >
                            {{ mode.name }}
                            <span v-if="index < equipment.classificationInfo.accessModes.length - 1"
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                      <v-col
                        v-if="equipment.classificationInfo.accessTypes.length"
                        cols="12"
                        md="2"
                        sm="12"
                      >
                        <label v-if="equipment.classificationInfo.accessTypes.length > 1"
                          >Access Types</label
                        >
                        <label v-else>Access Type</label>
                        <p>
                          <span
                            v-for="(type, index) in equipment.classificationInfo.accessTypes"
                            :key="index"
                          >
                            {{ type.name }}
                            <span v-if="index < equipment.classificationInfo.accessTypes.length - 1"
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="equipment.classificationInfo.targetUsers.length" class="mt-0 pt-0">
                      <v-col cols="12" md="6" sm="12">
                        <label v-if="equipment.classificationInfo.targetUsers.length > 1"
                          >Target Users</label
                        >
                        <label v-else>Targer User</label>
                        <p>
                          <span
                            v-for="(user, index) in equipment.classificationInfo.targetUsers"
                            :key="index"
                          >
                            {{ user.name }}
                            <span v-if="index < equipment.classificationInfo.targetUsers.length - 1"
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <!-- Contact Info -->
                  <!-- <v-tab-item
                    v-if="contactTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="2"
                  >
                    <v-row v-if="equipment.contactInfo.email">
                      <v-col cols="12" lg="5" xl="4" md="6" sm="12">
                        <v-card class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6 custom-card">
                          <v-row align="center">
                            <v-col cols="12" lg="3" xl="3" md="12" sm="12">
                              <v-card-text style="filter: blur(3px);">
                                <v-avatar
                                  :size="80"
                                  class="white--text text-bold"
                                  :color="'primary'"
                                >
                                  {{ letters }}
                                </v-avatar>
                              </v-card-text>
                            </v-col>
                            <v-col cols="12" lg="9" xl="9" md="12" sm="12">
                              <v-card-title
                                class="black--text text-bold"
                                style="filter: blur(4px);"
                              >
                                {{ equipment.contactInfo.lastname }}
                                {{ equipment.contactInfo.firstname }}
                              </v-card-title>
                              <v-card-text
                                class="mt-0 pt-0 primary200--text text-bold"
                                style="filter: blur(3px);"
                              >
                                {{ equipment.contactInfo.email }}
                              </v-card-text>
                              <v-card-text
                                class="mt-0 pt-0 primary200--text text-bold"
                                style="filter: blur(3px);"
                              >
                                {{ equipment.contactInfo.phone }}
                              </v-card-text>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-tab-item> -->

                  <!-- Management Info -->
                  <v-tab-item
                    v-if="managementTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="3"
                  >
                    <v-row v-if="equipment.managementInfo.equipmentServiceLevel" class="mt-10">
                      <v-col cols="12" md="6" sm="12">
                        <label>Service Level</label>
                        <p>
                          <a
                            @click="handleServiceLevelClick"
                            style="text-decoration: underline; color: inherit;"
                          >
                            {{ equipment.managementInfo.equipmentServiceLevel }}
                          </a>
                        </p>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <!-- Pricing Info -->
                  <v-tab-item
                    v-if="pricingTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="4"
                  >
                    <v-row v-if="equipment.pricingInfo.paymentModel" class="mt-10">
                      <v-col cols="12" md="6" sm="12">
                        <label>Payment Model</label>
                        <p>
                          {{ equipment.pricingInfo.paymentModel }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="equipment.pricingInfo.pricing" class="mt-0 pt-0">
                      <v-col cols="12" md="6" sm="12">
                        <label>Pricing</label>
                        <p>
                          {{ equipment.pricingInfo.pricing }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <!-- Additional Info -->
                  <v-tab-item
                    v-if="additionalInfoTab"
                    :transition="false"
                    :reverse-transition="false"
                    :key="5"
                  >
                    <v-row v-if="equipment.additionalInfo.helpDeskEmail" class="mt-10">
                      <v-col cols="12" md="6" sm="12">
                        <label>Help Desk</label>
                        <p>
                          {{ equipment.additionalInfo.helpDeskEmail }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="equipment.additionalInfo.standards.length" class="mt-0 pt-0">
                      <v-col cols="12" md="6" sm="12">
                        <label>Standards</label>
                        <p>
                          <span
                            v-for="(standard, index) in equipment.additionalInfo.standards"
                            :key="index"
                          >
                            {{ standard }}
                            <span v-if="index < equipment.additionalInfo.standards.length - 1"
                              >,
                            </span>
                          </span>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="equipment.additionalInfo.userManual" class="mt-0 pt-0">
                      <v-col cols="12" md="6" sm="12">
                        <label>User Manual</label>
                        <p>
                          <v-btn
                            :disabled="!$store.getters.roles"
                            v-if="equipment.additionalInfo.userManual"
                            @click="downloadUserManual(equipment.additionalInfo.userManual)"
                            icon
                            raised
                            small
                          >
                            <v-icon>mdi-file-pdf-box</v-icon>
                          </v-btn>
                          {{ equipment.additionalInfo.userManual }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row v-if="equipment.additionalInfo.termsOfUse" class="mt-0 pt-0">
                      <v-col cols="12" md="6" sm="12">
                        <label>Terms of use</label>
                        <p>
                          <v-btn
                            :disabled="!$store.getters.roles"
                            v-if="equipment.additionalInfo.termsOfUse"
                            @click="downloadTermsOfUse(equipment.additionalInfo.termsOfUse)"
                            icon
                            raised
                            small
                          >
                            <v-icon>mdi-file-pdf-box</v-icon>
                          </v-btn>
                          {{ equipment.additionalInfo.termsOfUse }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>

            <!-- Other Resources -->
            <v-card
              v-if="paginatedResources.length"
              class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
              elevation="3"
              style="border-radius: 24px;"
            >
              <v-card-title class="black--text mt-0 pt-0">
                <v-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  class="d-flex align-center justify-center justify-md-start justify-xl-start justify-lg-start mt-0 pt-0"
                >
                  Other Resources
                </v-col>
                <v-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  class="d-flex justify-center justify-md-end justify-xl-end justify-lg-end align-center mt-0 pt-0"
                >
                  <v-btn :disabled="currentPage === 1" @click="currentPage--" small plain>
                    <v-icon color="black" small class="mr-2">
                      mdi-arrow-left
                    </v-icon>
                  </v-btn>
                  <span> {{ currentPage }} / {{ totalPages }}</span>
                  <v-btn :disabled="currentPage === totalPages" @click="currentPage++" small plain>
                    <v-icon color="black" small class="mr-2">
                      mdi-arrow-right
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    xl="3"
                    lg="3"
                    md="3"
                    sm="6"
                    class="pa-3"
                    v-for="(resource, index) in paginatedResources"
                    :key="'resource-' + index"
                  >
                    <v-hover v-slot="{ hover }">
                      <v-card
                        class="d-flex justify-center align-center"
                        elevation="3"
                        style="border-radius: 24px; height: 100%;"
                        :class="{ 'on-hover': hover }"
                        @click="redirect(resource)"
                      >
                        <v-card-text>
                          <v-row align="center">
                            <v-col cols="12" xl="6" lg="12" md="12" sm="12" align="center">
                              <v-img
                                v-if="resource.logo"
                                height="120px"
                                max-width="80%"
                                contain
                                v-bind:src="resource.logo"
                                :style="{
                                  borderTopLeftRadius: '24px',
                                  borderTopRightRadius: '24px',
                                }"
                              ></v-img>
                              <v-img
                                v-else
                                height="120px"
                                max-width="80%"
                                contain
                                :src="require('@/assets/img/blur.jpg')"
                              />
                            </v-col>
                            <v-col cols="12" xl="6" lg="12" md="12" sm="12" align="center">
                              <div class="mt-0 pt-0">
                                <span class="text-bold black--text">
                                  {{ resource.name }}
                                </span>
                              </div>
                              <div class="mt-0 pt-0">
                                <span class="text-bold">
                                  {{ resource.orderable ? 'Orderable' : 'Non Orderable' }}
                                </span>
                              </div>
                              <div>
                                <v-chip
                                  depressed
                                  rounded
                                  small
                                  color="blue"
                                  class="white--text font-weight-bold"
                                >
                                  {{ resource.label }}
                                </v-chip>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-hover>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Order Equipment Dialog -->
            <v-dialog v-model="orderEquipmentDialog" max-width="1000px" persistent>
              <v-card
                class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8"
              >
                <v-card-title class="px-0 py-0">
                  <v-row class="mx-0 px-2" align="center">
                    <v-col cols="11" class="text-center d-flex justify-center align-center">
                      {{ !ordersPending ? 'Order Equipment' : 'Order Status' }}
                    </v-col>
                    <v-col cols="1" class="pl-0">
                      <v-btn fab small text @click="orderEquipmentDialog = false">
                        <v-icon color="neutral500">
                          mdi-close
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>

                <v-divider class="custom-divider"></v-divider>

                <v-card-text v-if="!ordersPending" class="mt-10">
                  <v-form ref="orderEquipmentForm" v-model="valid" :lazy-validation="false">
                    <v-row>
                      <v-col cols="12" class="pt-0">
                        <p class="label-info">
                          Payments and pricing must by discussed directly with the service provider
                        </p>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <v-menu
                          v-model="dateFromMenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              v-model="equipmentOrder.dateFrom"
                              label="Date From"
                              append-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              class="required"
                              :rules="requiredRule()"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="equipmentOrder.dateFrom"
                            @input="dateFromMenu = false"
                            color="rgba(157, 87, 244, 1)"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <v-menu
                          v-model="dateToMenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              v-model="equipmentOrder.dateTo"
                              label="Date To"
                              append-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              class="required"
                              :rules="requiredRule()"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="equipmentOrder.dateTo"
                            @input="dateToMenu = false"
                            color="rgba(157, 87, 244, 1)"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <label>Use Case*</label>
                        <v-textarea
                          v-model="equipmentOrder.useCase"
                          :placeholder="'Use Case'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <label>Additional Prerequisites</label>
                        <p class="label-info">{{ $t('order-additional-info-text') }}</p>
                        <v-textarea
                          v-model="equipmentOrder.additionalInformation"
                          :placeholder="'Additional Prerequisites'"
                          outlined
                          clearable
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <v-checkbox
                          :rules="requiredRule()"
                          label="I acknowledge that the order adheres to the service’s prerequisites"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-text v-else>
                  <v-row>
                    <v-col cols="12">
                      <v-data-table
                        :headers="headersOrder"
                        :items="orders"
                        hide-default-footer
                        disable-pagination
                      >
                        <template v-slot:item.orderDate="{ item }">
                          <span>
                            {{ formatDateLocaleAE(item.createdTimestamp) }}
                          </span>
                        </template>
                        <template v-slot:item.status="{ item }">
                          <v-chip :color="getOrderColor(item.status.id)">
                            {{
                              item.status.description +
                                (item.statusExplicit ? ' - ' + item.statusExplicit : '')
                            }}
                          </v-chip>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-actions v-if="!ordersPending">
                  <v-row style="width: 100%">
                    <v-col cols="6">
                      <v-btn
                        block
                        depressed
                        rounded
                        large
                        class="neutral800--text font-weight-bold"
                        color="neutral"
                        outlined
                        @click="cancelEquipmentOrder"
                        >{{ $t('cancel') }}
                      </v-btn>
                    </v-col>
                    <v-col cols="6">
                      <v-btn
                        :disabled="!valid"
                        block
                        depressed
                        rounded
                        large
                        class="white--text font-weight-bold"
                        color="black"
                        @click="submitEquipmentOrder"
                        >{{ $t('submit') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>

        <!-- Non registered dialog -->
        <v-dialog v-model="modalLogIn" max-width="1000px">
          <v-card
            class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8"
          >
            <v-card-title class="px-0 py-0">
              <v-row class="mx-0 px-2" align="center">
                <v-col cols="11" class="text-center d-flex justify-center align-center">
                  This action requires authentication
                </v-col>
                <v-col cols="1" class="pl-0">
                  <v-btn fab small text @click="modalLogIn = false">
                    <v-icon color="neutral500">
                      mdi-close
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider class="mt-1 mb-6 my-sm-6 my-lg-6 my-xl-6 my-md-6"></v-divider>
            <v-card-text class="pa-0 text-center">
              Only authenticated users are allowed to perform this action. Please
              <router-link :to="{ name: 'OverviewEquipment', params: { id: $route.params.id } }"
                ><span class="font-weight-bold">Log In</span></router-link
              >
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
  </div>
</template>

<script>
import util from '@/mixins/util.js';
import EventBus from '@/helpers/event-bus.js';

export default {
  name: 'PublicOverviewEquipment',
  mixins: [util],
  data() {
    return {
      equipment: {
        picture: null,
        email: null,
        logo: null,
        name: '',
        description: '',
        provider: {
          name: '',
          hostingInstitution: '',
          id: '',
        },
        tags: [],
        orderable: false,
        views: null,
        nonRegisteredViews: null,
        basicInfo: {
          prerequisites: '',
          webpage: '',
          tagline: '',
          useCases: [],
          manufacturer: '',
          modelAndType: '',
          operationalMode: '',
          availabilityPolicy: '',
        },
        classificationInfo: {
          domains: [],
          categories: [],
          accessModes: [],
          accessTypes: [],
          targetUsers: [],
        },
        contactInfo: {
          firstname: '',
          lastname: '',
          email: '',
          phone: '',
        },
        managementInfo: {
          equipmentServiceLevel: '',
        },
        pricingInfo: {
          paymentModel: '',
          pricing: '',
        },
        additionalInfo: {
          helpDeskEmail: '',
          standards: [],
          userManual: null,
          termsOfUse: null,
        },
      },
      equipmentOrder: {
        useCase: '',
        dateFrom: null,
        dateTo: null,
        additionalInformation: '',
      },
      isFavorite: false,
      orderEquipmentDialog: false,
      dateFromMenu: false,
      dateToMenu: false,
      valid: false,
      orderPending: false,
      tab: null,
      letters: '',
      marketplaceEquipmentViewAll: '',
      resources: [],
      resource: {
        picture: '',
      },
      currentPage: 1,
      itemsPerPage: 8,
      statusIds: [],
      orders: [],
      isVerified: {
        verified: false,
      },
      modalLogIn: false,
      equipmentSearchMarketplaceQuery: '',
    };
  },
  mounted() {
    this.getEquipment();
    this.marketplaceEquipmentViewAll = this.$route.query.marketplaceEquipmentViewAll;
    this.equipmentSearchMarketplaceQuery = this.$route.query.equipmentSearchMarketplace;

    this.getOrders();
  },
  beforeUpdate() {
    const { firstname, lastname } = this.equipment.contactInfo;
    this.letters = '';

    if (lastname && firstname) {
      this.letters = lastname.charAt(0) + firstname.charAt(0);
    }
  },
  computed: {
    basicInfoTab() {
      if (
        this.equipment.basicInfo.prerequisites ||
        this.equipment.basicInfo.webpage ||
        this.equipment.basicInfo.tagline ||
        this.equipment.basicInfo.useCases.length ||
        this.equipment.basicInfo.manufacturer ||
        this.equipment.basicInfo.modelAndType ||
        this.equipment.basicInfo.operationalMode ||
        this.equipment.basicInfo.availabilityPolicy
      ) {
        return true;
      } else {
        return false;
      }
    },
    classificationTab() {
      if (
        this.equipment.classificationInfo.domains.length ||
        this.equipment.classificationInfo.categories.length ||
        this.equipment.classificationInfo.accessModes.length ||
        this.equipment.classificationInfo.accessTypes.length ||
        this.equipment.classificationInfo.targetUsers.length
      ) {
        return true;
      } else {
        return false;
      }
    },
    contactTab() {
      if (this.equipment.contactInfo.email) {
        return true;
      } else {
        return false;
      }
    },
    additionalInfoTab() {
      if (
        this.equipment.additionalInfo.helpDeskEmail ||
        this.equipment.additionalInfo.standards.length ||
        this.equipment.additionalInfo.userManual ||
        this.equipment.additionalInfo.termsOfUse
      ) {
        return true;
      } else {
        return false;
      }
    },
    pricingTab() {
      if (this.equipment.pricingInfo.pricing || this.equipment.pricingInfo.paymentModel) {
        return true;
      } else {
        return false;
      }
    },
    managementTab() {
      if (this.equipment.managementInfo.equipmentServiceLevel) {
        return true;
      } else {
        return false;
      }
    },
    totalPages() {
      return Math.ceil(this.resources.length / this.itemsPerPage);
    },
    paginatedResources() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.resources.slice(start, end);
    },
    orderDisabled() {
      return !this.equipment.orderable || !['researcher'].includes(this.$store.getters.roles);
    },
    ordersPending() {
      return this.statusIds.some(status =>
        ['REQUESTED', 'ACCEPTED_BY_PROVIDER', 'ACCEPTED_BY_RESEARCHER'].includes(status),
      );
    },
    headersOrder() {
      let headers = [
        { text: 'Order Date', value: 'orderDate', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Use Case', value: 'useCase', sortable: true },
        { text: 'Additional Prerequisites', value: 'additionalInformation', sortable: true },
      ];
      return headers;
    },
  },
  methods: {
    getEquipment() {
      EventBus.$emit('waiting', true);
      const id = this.$route.params.id;

      this.axios
        .get(`/api/v1/equipment/${id}`)
        .then(response => {
          console.log('Get Equipment', response.data);
          this.isFavorite = response.data.isFavorite;

          this.equipment.logo = response.data.logo;
          this.equipment.picture = response.data.picture;
          this.equipment.name = response.data.name;
          this.equipment.description = response.data.description;
          this.equipment.provider = {
            name: response.data.provider.name,
            hostingInstitution: response.data.provider.hostingInstitution,
            id: response.data.provider.id,
          };
          this.equipment.tags = response.data.tags;
          this.equipment.orderable = response.data.orderable;
          this.equipment.views = response.data.views;
          this.equipment.nonRegisteredViews = response.data.viewsNonRegistered;
          this.equipment.basicInfo = {
            prerequisites: response.data.prerequisites,
            webpage: response.data.webpage,
            tagline: response.data.tagline,
            useCases: response.data.useCases,
            manufacturer: response.data.equipmentManufacturer,
            modelAndType: response.data.modelAndType,
            operationalMode: response.data.operationalMode?.name,
            availabilityPolicy: response.data.availabilityPolicy,
          };
          this.equipment.classificationInfo = {
            domains: response.data.scientifics,
            categories: response.data.categories,
            accessModes: response.data.accessModes,
            accessTypes: response.data.accessTypes,
            targetUsers: response.data.targets,
          };

          const verifiedContact = response.data.publicContacts?.find(
            contact => contact.verified === true,
          );

          this.isVerified.verified = verifiedContact ? verifiedContact.verified : false;

          this.equipment.contactInfo = {
            firstname: verifiedContact?.firstname,
            lastname: verifiedContact?.lastname,
            email: verifiedContact?.email,
            phone: verifiedContact?.phone,
            verified: verifiedContact ? verifiedContact.verified : false,
          };
          // this.equipment.contactInfo = {
          //   firstname:
          //     response.data.publicContacts && response.data.publicContacts.length > 0
          //       ? response.data.publicContacts[0].firstname
          //       : '-',
          //   lastname:
          //     response.data.publicContacts && response.data.publicContacts.length > 0
          //       ? response.data.publicContacts[0].lastname
          //       : '-',
          //   email:
          //     response.data.publicContacts && response.data.publicContacts.length > 0
          //       ? response.data.publicContacts[0].email
          //       : '-',
          //   phone:
          //     response.data.publicContacts && response.data.publicContacts.length > 0
          //       ? response.data.publicContacts[0].phone
          //       : '-',
          // };
          this.equipment.managementInfo = {
            equipmentServiceLevel: response.data.equipmentServiceLevel,
          };
          this.equipment.pricingInfo = {
            paymentModel: response.data.paymentModel
              ? response.data.paymentModel.replace(/<\/?[^>]+>/g, '')
              : '',
            pricing: response.data.pricing ? response.data.pricing.replace(/<\/?[^>]+>/g, '') : '',
          };
          this.equipment.additionalInfo = {
            helpDeskEmail: response.data.helpDeskEmail,
            standards: response.data.standards,
            userManual: response.data.userManual,
            termsOfUse: response.data.termsOfUse,
          };
          this.getOtherResources(this.equipment);
        })
        .catch(error => {
          console.error('Error fetching equipment data:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    getOtherResources(equipment) {
      EventBus.$emit('waiting', true);

      const providerId = equipment.provider.id;
      const excludedId = this.$route.params.id;

      this.axios
        .get(`api/v1/equipment/other-resources`, {
          params: {
            providerId,
          },
        })
        .then(response => {
          console.log('Response data from Other Resources:', response.data);

          this.resources = response.data.filter(
            resource => resource.id !== parseInt(excludedId, 10),
          );

          this.currentPage = 1;
        })
        .catch(error => {
          console.error('Error fetching other resources:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    handleServiceLevelClick() {
      const url = this.equipment.managementInfo.equipmentServiceLevel;
      if (url) {
        window.open(url, '_blank');
      } else {
        console.log('No valid URL found');
      }
    },
    downloadUserManual(file) {
      const id = this.$route.params.id;
      const filePath = `api/v1/equipment/${id}/file/${file}?field=userManual`;

      this.axios
        .get(filePath, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], {
            type: response.headers['content-type'],
          });

          const fileURL = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = fileURL;
          a.download = file;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          URL.revokeObjectURL(fileURL);
        })
        .catch(error => {
          console.error('Error fetching file:', error);
        });
    },
    downloadTermsOfUse(file) {
      const id = this.$route.params.id;
      const filePath = `api/v1/equipment/${id}/file/${file}?field=termsOfUse`;

      this.axios
        .get(filePath, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], {
            type: response.headers['content-type'],
          });

          const fileURL = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = fileURL;
          a.download = file;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          URL.revokeObjectURL(fileURL);
        })
        .catch(error => {
          console.error('Error fetching file:', error);
        });
    },
    redirect(resource) {
      const id = resource.id;
      const label = resource.label;

      if (id && label === 'Service' && !this.$store.getters.roles) {
        this.$router.push({ name: 'PublicOverviewService', params: { id: id } });
      }

      if (id && label === 'Patent' && !this.$store.getters.roles) {
        this.$router.push({ name: 'PublicOverviewPatent', params: { id: id } });
      }

      if (id && label === 'Equipment' && !this.$store.getters.roles) {
        this.$router.push({ name: 'PublicOverviewEquipment', params: { id: id } });
        this.$nextTick(() => {
          this.getEquipment();
        });
      }
    },
    addFavorite() {
      const id = this.$route.params.id;

      EventBus.$emit('waiting', true);

      this.axios
        .post(`/api/v1/favorites-equipments/${id}`)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: 'Favorite added successfully',
          });
          this.isFavorite = true;
        })
        .catch(error => {
          EventBus.$emit('snackbar', {
            text: error.response.data,
            color: 'warning',
          });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    removeFavorite() {
      const id = this.$route.params.id;

      EventBus.$emit('waiting', true);

      this.axios
        .delete(`/api/v1/favorites-equipments/${id}`)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: 'Favorite removed successfully',
          });
          this.isFavorite = false;
        })
        .catch(error => {
          EventBus.$emit('snackbar', {
            text: error.response.data,
            color: 'warning',
          });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    cancelEquipmentOrder() {
      this.equipmentOrder.useCase = '';
      this.equipmentOrder.dateFrom = null;
      this.equipmentOrder.dateTo = null;
      this.equipmentOrder.additionalInformation = '';
      this.orderEquipmentDialog = false;
    },
    getOrders() {
      const id = this.$route.params.id;
      if (this.$store.getters.roles === 'researcher') {
        this.axios
          .get(`api/v1/orders-equipment?equipmentId=${id}`)
          .then(response => {
            this.orders = response.data.content;
            this.statusIds = this.orders.map(order => order.status?.id);
            console.log('Get Orders:', this.orders);
          })
          .catch(error => {
            console.error('Error fetching data:', error);
          });
      }
    },
    submitEquipmentOrder() {
      EventBus.$emit('waiting', true);

      const id = this.$route.params.id;

      const payload = {
        equipment: {
          id: id,
          name: this.equipment.name,
        },
        fromDate: this.equipmentOrder.dateFrom,
        toDate: this.equipmentOrder.dateTo,
        useCase: this.equipmentOrder.useCase,
        additionalInformation: this.equipmentOrder.additionalInformation,
      };

      this.axios
        .post(`/api/v1/orders-equipment`, payload)
        .then(response => {
          console.log('Order submitted successfully:', response.data);
          EventBus.$emit('snackbar', {
            text: 'Order successfully submitted',
          });
          this.orderEquipmentDialog = false;
          this.orderPending = true;
          this.statusId = 'REQUESTED';
          this.getOrders();
        })
        .catch(error => {
          console.error('There was an error submitting the order:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    goBack() {
      if (this.marketplaceEquipmentViewAll && this.$route.query.fromTable) {
        const marketplaceEquipmentViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Equipment';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/equipment';
        const fromTable = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceEquipmentViewAll, ...fromTable },
        });
      } else if (this.marketplaceEquipmentViewAll && this.$route.query.filters) {
        const marketplaceEquipmentViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Equipment';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/Equipment';
        const filters = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceEquipmentViewAll, ...filters },
        });
      } else if (this.equipmentSearchMarketplaceQuery && this.$route.query.filters) {
        localStorage.setItem('tabIndex', 1);
        const filters = this.$route.query;
        this.$router.push({
          name: 'PublicSearchMarketplace',
          query: filters,
        });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style>
.custom-divider {
  padding: 5px 0;
  margin: 25px 35px 0px 35px;
  border-top-width: 2px;
  border-top-style: solid;
  border-top-color: rgba(195, 194, 199, 1);
}

#overview-equipment-tab .v-toolbar {
  background: rgba(250, 250, 250, 1) !important;
  border-bottom: 2px solid #f4f2f9 !important;
}

#overview-equipment-tab .custom-app-bar {
  background-color: rgba(0, 0, 0, 0) !important;
  border-bottom: none !important;
}
</style>
